// Google Analytics 4 — minimal install for StoneCrest.
// Page views are handled by GA4 Enhanced Measurement (incl. SPA history changes).
// Custom events: quote_submit, contact_submit, phone_click, email_click.
// No personal data is ever sent to GA.
const GA4_ID = process.env.REACT_APP_GA4_ID || "G-N8TGN9K76G";

let initialized = false;
const _recent = {};
function _dedupe(key, ms = 1000) {
  const now = Date.now();
  if (_recent[key] && now - _recent[key] < ms) return false;
  _recent[key] = now;
  return true;
}

const CONSENT_KEY = "sc_cookie_consent";

export function getConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

// Store the visitor's choice. GA4 only ever loads once consent === "accepted".
export function setConsent(value) {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* ignore */ }
  if (value === "accepted") initAnalytics();
}

export function initAnalytics() {
  if (getConsent() !== "accepted") return; // consent-gated: never load GA without opt-in
  if (initialized || !GA4_ID) return;
  initialized = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID); // Enhanced Measurement handles page_view (incl. SPA)
}

function _fire(name, dedupeKey = "") {
  if (!window.gtag) return;
  if (!_dedupe(`${name}:${dedupeKey}`)) return;
  window.gtag("event", name); // no parameters => no PII
}

export function trackQuoteSubmit() { _fire("quote_submit"); }
export function trackContactSubmit() { _fire("contact_submit"); }

// Delegated listener so every existing tel:/mailto: link is covered without editing each.
export function initInteractionTracking() {
  if (window.__scClickTracking) return;
  window.__scClickTracking = true;
  document.addEventListener("click", (e) => {
    const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    const href = a.getAttribute("href") || "";
    if (href.startsWith("tel:")) _fire("phone_click", href);
    else if (href.startsWith("mailto:")) _fire("email_click", href);
  }, true);
}

// Legacy no-ops kept so existing imports don't break and no non-requested events fire.
export function trackCallConversion() {}
export function trackQuoteConversion() {}
export function trackPageView() {}
